import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import colors from "theme/base/colors";
import SPINNER_MODE from "enums/SPINNER_MODE";
import TransitionalRegion from "./TransitionalRegion";

interface Props {
  children: React.ReactNode;
  minimumLoadingTime?: number;
}

export default function AppLoadingScreen({
  children,
  minimumLoadingTime = 2000,
}: Props) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, minimumLoadingTime);

    return () => clearTimeout(timer);
  }, [minimumLoadingTime]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
      }}
    >
      <TransitionalRegion
        sx={{ backgroundColor: colors.white.main }}
        showSpinner={isLoading}
        spinnerMode={SPINNER_MODE.BUTTERFLY}
      >
        {children}
      </TransitionalRegion>
    </Box>
  );
}
